import React from 'react';
import Icon from "../";
export default function IconHelpAlt(props) {
  return React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<circle cx=\"12\" cy=\"12\" r=\"9.5\" fill=\"none\" stroke=\"#181818\"/><path d=\"M9.72 10.26a2.65 2.65 0 01.52-2.43 2.67 2.67 0 013-.64 2.39 2.39 0 011.44 1.93 2.67 2.67 0 01-1.18 2.28c-.38.33-1.33.83-1.46 1.7 0 .33-.05 1.18-.05 1.18\" fill=\"none\" stroke=\"#181818\"/><circle cx=\"12\" cy=\"16.65\" r=\".35\" fill=\"#181818\" stroke=\"#181818\"/>"
    }
  }));
}